import { getParam } from "../util/util";

let config = {
    locale: 'zh'
};


let htconfig = window.htconfig;
if (htconfig && htconfig.Project) {
    config = Object.assign(config, htconfig.Project);
}


let paramLocale = getParam('locale');
if (paramLocale) {
    config.locale = paramLocale;
}

export default config;